import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { AppBar, createStyles, FormControlLabel, TextField, Theme, Toolbar, Typography, withStyles, WithStyles } from '@material-ui/core';
import { DeltaXMLColors } from './styling/DeltaColors';

const styles = (theme: Theme) =>
  createStyles({
    appBar: {
      alignItems: "left",
      backgroundColor: DeltaXMLColors.OXFORD_BLUE,
    },
    textField: {
      margin: theme.spacing(1),
      minWidth: 180
    },
  });

export interface ErrorData {
  fulfillmentSize: string | null,
}

export interface PartialFullmentDialogProps extends WithStyles<typeof styles> {
  availableSize: number;
  dialogOpen: boolean;
  handleCloseDialog: () => void;
  partialFulfillmentConfirm: (fulfillmentSize: number) => void;
}

function PartialFulfillmentDialog(props: PartialFullmentDialogProps) {
  const { classes, availableSize, dialogOpen, handleCloseDialog, partialFulfillmentConfirm} = props;
  const [fulfillmentSize, setFulfillmentSize] = React.useState('');

  const initialErrorData: ErrorData = {
    fulfillmentSize: 'Enter Size',
  }
  const [errorData, setErrorData] = React.useState(initialErrorData);

  const handlefulfillmentSizeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFulfillmentSize(event.target.value);
    if (event.target.value === "") {
      setErrorData({ ...errorData, fulfillmentSize: 'Enter Size' })
    } else {
      const updatedfulfillmentSize: number = Number(event.target.value);
      if (isNaN(updatedfulfillmentSize)) {
        setErrorData({ ...errorData, fulfillmentSize: 'Invalid Size' })
      } else if (!isNaN(updatedfulfillmentSize) && (updatedfulfillmentSize <= 0)) {
        setErrorData({ ...errorData, fulfillmentSize: 'Size must be greater than 0' });
      } else if (updatedfulfillmentSize > availableSize) {
        setErrorData({ ...errorData, fulfillmentSize: 'Size is greater than available' });
      } else {
        setErrorData({ ...errorData, fulfillmentSize: null });
      }
    }
  }

  const onClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    partialFulfillmentConfirm(Number(fulfillmentSize));
    setFulfillmentSize("");
    setErrorData({ ...errorData, fulfillmentSize: 'Enter Size' })
  }

  const fieldsWithNoErrors = (errorData: ErrorData): boolean => {
    let fieldsWithNoErrors: boolean = false;
    const otherError = Object.entries(errorData).find((property) => {
      const [name, value] = property;
      return value !== null;
    });
    if (!otherError) {
      fieldsWithNoErrors = true;
    }
    return fieldsWithNoErrors;
  }

  const enableConfirmButton: boolean = fieldsWithNoErrors(errorData);

  return (
    <Dialog open={dialogOpen}>
      <AppBar className={classes.appBar} position="static">
        <Toolbar>
          <Typography variant="h4">Create System</Typography>
        </Toolbar>
      </AppBar>
      <br />

      <DialogContent>
        <FormControlLabel
          control={<TextField className={classes.textField} value={fulfillmentSize} onChange={handlefulfillmentSizeChange}
            helperText={errorData.fulfillmentSize !== null ? errorData.fulfillmentSize : "Valid Size"} error={errorData.fulfillmentSize !== null} />}
          label="Enter size to create a system:"
          labelPlacement="top"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={event => onClick(event)} variant="contained" color="primary"
          disabled={!(enableConfirmButton)}>
          Confirm
        </Button>
        <Button onClick={handleCloseDialog} variant="contained" color="primary" >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
export default withStyles(styles)(PartialFulfillmentDialog);